import { IconProps } from '../';
const CloseHamburgerIcon = ({
  color = 'var(--color-ui-knockout-primary)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M17 17.0009L41.1994 41.2003" stroke={color} strokeWidth="2" />
      <path
        d="M17.0039 41.0012L41.2034 16.8018"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default CloseHamburgerIcon;
